import { render, staticRenderFns } from "./S12.vue?vue&type=template&id=5a64c700&scoped=true&"
import script from "./S12.vue?vue&type=script&lang=js&"
export * from "./S12.vue?vue&type=script&lang=js&"
import style0 from "./S12.vue?vue&type=style&index=0&id=5a64c700&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a64c700",
  null
  
)

export default component.exports